import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import MessageCenterFooter from '../../components/MessageCenterFooter/MessageCenterFooter';
import MessageCompositionBody from '../../components/MessageCompositionBody/MessageCompositionBody.js';
import styles from './Compose.module.scss';

const Compose = ({
  accountTypes,
  apiKey,
  baseUrl,
  customerType,
  env,
  messageFromId,
  openModal,
  transition
}) => {
  return (
    <Fragment>
      <div className={styles['compose-container']}>
        <h2 className={`${styles.header} branded-header`} id="compose-title">
          Compose a New Message
        </h2>
        <div className={styles['compose-main']}>
          <MessageCompositionBody
            accountTypes={accountTypes}
            apiKey={apiKey}
            baseUrl={baseUrl}
            customerType={customerType}
            env={env}
            messageFromId={messageFromId}
            openModal={openModal}
            transition={transition}
          />
        </div>
        <MessageCenterFooter
          leftText={
            <span>
              Please be advised that financial transactions cannot be handled by
              email.
            </span>
          }
        />
      </div>
    </Fragment>
  );
};

Compose.propTypes = {
  accountTypes: PropTypes.arrayOf(PropTypes.number),
  apiKey: PropTypes.string,
  baseUrl: PropTypes.string,
  customerType: PropTypes.number,
  env: PropTypes.string,
  messageFromId: PropTypes.string,
  openModal: PropTypes.func,
  transition: PropTypes.func,
  webViewEnabled: PropTypes.bool
};

export default Compose;
